angular.module('unica_event_tag.event_tag_services')

.factory('EventTagCreateService', function ($http, getBaseApiURL) {

	var eventTagCreateService = {};

	eventTagCreateService.create = function ( eventTagData) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/event-tag/create',
			data: eventTagData
		}).then(function(result) {

			if ( result ) {
				return result.data.eventTag;
			}

		});
 
	};

	return eventTagCreateService;
});